<template>
    <i class="ico-svg-star">
        <svg v-bind="{ width, height }" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 7.864L2.893 8.902c-.444.219-.992.059-1.226-.357a.805.805 0 01-.09-.54l.402-2.2L.274 4.249a.814.814 0 01-.016-1.203.93.93 0 01.52-.249l2.355-.32L4.186.475c.222-.422.766-.595 1.216-.387a.881.881 0 01.412.387l1.053 2 2.356.321c.496.068.84.5.767.965a.834.834 0 01-.264.487L8.02 5.806l.403 2.199c.084.463-.247.903-.741.983a.96.96 0 01-.576-.086L5 7.864z" :fill="color"/>
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconStar',

    props: {
        width: {
            type: Number,
            default: 10,
        },

        height: {
            type: Number,
            default: 9,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
